import { render, staticRenderFns } from "./itemConfig.vue?vue&type=template&id=c0ff8408&scoped=true&"
import script from "./itemConfig.vue?vue&type=script&lang=js&"
export * from "./itemConfig.vue?vue&type=script&lang=js&"
import style0 from "./itemConfig.vue?vue&type=style&index=0&id=c0ff8408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ff8408",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0ff8408')) {
      api.createRecord('c0ff8408', component.options)
    } else {
      api.reload('c0ff8408', component.options)
    }
    module.hot.accept("./itemConfig.vue?vue&type=template&id=c0ff8408&scoped=true&", function () {
      api.rerender('c0ff8408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/formSys/itemConfig.vue"
export default component.exports